export default function inputIconDirective() {
	return {
		restrict: 'A',
		scope: false,
		controller: inputIconDirectiveCtrl,
	};
}

class inputIconDirectiveCtrl {
	// USAGE
	// <input type="text" class="form-input" sh-input-icon="search" sh-input-icon-side="left">
	constructor($element, $attrs) {
		'ngInject';
		let input = $element[0];
		let { wrapper, icon } = this.wrap(input, $attrs.shInputIcon);
		// add the input icon to the right of the input unless left is specified
		if ($attrs.shInputIconSide == 'left') {
			wrapper.insertBefore(icon, input);
			wrapper.className += ' ico-left';
		} else {
			wrapper.appendChild(icon);
			wrapper.className += ' ico-right';
		}
	}

	wrap(input, iconName) {
		// wrap the input in a span we can use to position the icon
		let wrapper = document.createElement('span');
		wrapper.className = 'iconned-wrapper';
		// create an icon with the given name
		let icon = document.createElement('span');
		icon.className = 'icons icon-' + iconName;
		// wrap it
		input.parentNode.insertBefore(wrapper, input);
		wrapper.appendChild(input);
		return { wrapper, icon };
	}
}
